import axios from 'axios';

export const apiBaseUrl = process.env.REACT_APP_ZYNITY_API_URL || '';

// Apply global axios defaults for a single API base host.
axios.defaults.baseURL = apiBaseUrl;

export const apiClient = axios.create({
  baseURL: apiBaseUrl,
});

export const buildApiUrl = (path: string) => {
  if (!path) return apiBaseUrl;
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${apiBaseUrl}${normalizedPath}`;
};
